/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Ekle"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Tümünü kaldır"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var trTR = Object.assign(TranslationProviderComponent, {
  translations
});

export { trTR as t };
//# sourceMappingURL=tr-TR-DdfmFkCz.js.map
